module.exports = __webpack_public_path__ + "img/26Roosevelt.1220be5f.png";